import React from 'react';
import pageAssets from '../../../../data/pageAssets';
import AppImage from '../../../common/media/AppImage';

const FansHeroSection = ({ hero }) => (
    <section id="fans-hero" className="about-fans-hero">
        <div className="container">
            <div className="about-fans-hero-grid">
                <div className="about-fans-hero-content">
                    <div className="about-fans-hero-badge">{hero.badge}</div>
                    <h1 className="about-fans-hero-title">
                        {hero.titleLine1} <span>&</span><br />
                        <span>{hero.titleLine2}</span>
                    </h1>
                    <p className="about-fans-hero-description">{hero.description}</p>
                    <div className="about-fans-hero-actions">
                        <button type="button" className="btn btn-primary btn-lg" onClick={() => document.getElementById('fan-catalog')?.scrollIntoView({ behavior: 'smooth' })}>
                            {hero.primaryCtaLabel}
                        </button>
                    </div>
                </div>
                <div className="about-fans-hero-image">
                    <AppImage src={pageAssets[hero.imageKey]} alt={hero.imageAlt} priority width="500" height="500" />
                    <div className="about-fans-floating-badge">{hero.floatingBadge}</div>
                </div>
            </div>
        </div>
    </section>
);

export default FansHeroSection;
